import { VueComponent } from "../../shared/types/VueComponent";

export type ChipConfig = {
  label: string
  view: VueComponent
  color?: string
  typeKey: string
  isDefault?: boolean
  prefix?: string,
  icon?: {
    name: string
    iconPack: string
    color?: string
  }
}

export type PossibleChipTypeInfo = Record<string, ChipConfig>

export type RawChipItem = Record<string, any>

export type RawFrontendChipItem = {
  type: string
  guid?: string | null
  info?: ChipConfig
  model: Record<string, any> | null
}

export const enum ModalAction {
  new = 'new',
  edit = 'edit'
}
